import { useEffect } from "react";

/**
 * Calls `onClose` when the user presses the Escape key, only while `active` is true.
 *
 * Use this for modals/sheets/drawers you control directly. For a no-code global
 * Escape behaviour across legacy modals, see <GlobalEscapeHandler /> in App.js.
 *
 * Usage:
 *   const [open, setOpen] = useState(false);
 *   useEscapeToClose(open, () => setOpen(false));
 */
export default function useEscapeToClose(active, onClose) {
  useEffect(() => {
    if (!active || typeof onClose !== "function") return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        e.stopPropagation();
        onClose(e);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [active, onClose]);
}
